export const toTelHref = (phone: string): string => phone.replace(/[\s()\-]/g, '');
